"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.attributeTypeBadRule = void 0;
exports.getAttributesWithBadType = getAttributesWithBadType;
exports.suggestedAttributeType = suggestedAttributeType;
const utils_1 = require("@azimutt/utils");
const database_1 = require("../../database");
const databaseUtils_1 = require("../../databaseUtils");
const rule_1 = require("../rule");
const ruleId = 'attribute-type-bad';
const ruleName = 'bad attribute type';
const ruleDescription = 'text attributes with all statistic values that could have been an other type (int, decimal, uuid, timestamp)';
const CustomRuleConf = rule_1.RuleConf.extend({
    ignores: database_1.AttributeId.array().optional()
}).strict().describe('AttributeTypeBadConf');
exports.attributeTypeBadRule = {
    id: ruleId,
    name: ruleName,
    description: ruleDescription,
    conf: { level: rule_1.RuleLevel.enum.medium },
    zConf: CustomRuleConf,
    analyze(conf, now, db, queries, history, reference) {
        const refIgnores = reference.map(r => r.entity && r.attribute ? { ...r.entity, attribute: r.attribute } : undefined).filter(utils_1.isNotUndefined);
        const ignores = refIgnores.concat(conf.ignores?.map(databaseUtils_1.attributeRefFromId) || []);
        return (db.entities || [])
            .flatMap(getAttributesWithBadType)
            .filter(r => !ignores.some(i => (0, databaseUtils_1.attributeRefSame)(i, r.ref)))
            .map(r => ({
            ruleId,
            ruleName,
            ruleLevel: conf.level,
            message: `Attribute ${(0, databaseUtils_1.attributeRefToId)(r.ref)} with type ${r.type} could have type ${r.suggestion}.`,
            entity: (0, databaseUtils_1.attributeRefToEntity)(r.ref),
            attribute: r.ref.attribute,
            extra: { attribute: r.ref, currentType: r.type, suggestedType: r.suggestion, sampleValues: r.values.slice(0, 10) }
        }));
    }
};
function getAttributesWithBadType(entity) {
    return (entity.attrs || []).map(a => {
        const suggestion = suggestedAttributeType(a);
        return suggestion ? { ref: { ...(0, databaseUtils_1.entityToRef)(entity), attribute: [a.name] }, type: a.type, ...suggestion } : undefined;
    }).filter(utils_1.isNotUndefined);
}
function suggestedAttributeType(a) {
    const type = (0, databaseUtils_1.attributeTypeParse)(a.type);
    const values = [
        ...a.stats?.commonValues?.map(v => v.value) || [],
        ...a.stats?.histogram || [],
        ...a.stats?.distinctValues || [],
    ].filter((v) => typeof v === 'string');
    if (type.kind === database_1.AttributeTypeKind.enum.string && values.length > 0) {
        if (values.every(utils_1.stringIsISODate))
            return { suggestion: 'timestamp', values: values };
        if (values.every(utils_1.stringIsUuid))
            return { suggestion: 'uuid', values: values };
        if (values.every(utils_1.stringIsInt))
            return { suggestion: 'int', values: values };
        if (values.every(utils_1.stringIsFloat))
            return { suggestion: 'decimal', values: values };
    }
    return undefined;
}
//# sourceMappingURL=attributeTypeBad.js.map